(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["catalina-collection-nav"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('catalina-collection-nav')) {
  customElements.define('catalina-collection-nav', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController(); const options = { signal: this.abort.signal };
      this.viewport = this.querySelector('[data-ccn-viewport]'); this.list = this.querySelector('[data-ccn-list]');
      if (!this.viewport || !this.list) return;
      this.previous = this.querySelector('[data-ccn-prev]'); this.next = this.querySelector('[data-ccn-next]');
      this.previous.addEventListener('click', () => this.step(-1), options); this.next.addEventListener('click', () => this.step(1), options);
      this.viewport.addEventListener('scroll', () => this.queue(), { ...options, passive: true });
      window.addEventListener('popstate', () => this.refresh(), options); window.addEventListener('pageshow', () => this.refresh(), options);
      document.addEventListener('shopify:collection:update', () => this.refresh(), options);
      document.addEventListener('shopify:block:select', event => {
        const item = [...this.querySelectorAll('[data-ccn-block]')].find(node => node.dataset.ccnBlock === event.detail?.blockId || node.contains(event.target));
        if (item) this.reveal(item);
      }, options);
      this.observer = new ResizeObserver(() => this.queue()); this.observer.observe(this.viewport); this.observer.observe(this.list);
      document.fonts?.ready.then(() => { if (this.isConnected) { this.update(); this.revealCurrent(); } });
      this.refresh(); this.frame = requestAnimationFrame(() => { this.update(); this.revealCurrent(); });
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame); }
    tags() {
      const tags = new Set((this.dataset.knownTags || '').split('|').filter(Boolean));
      document.querySelectorAll('catalina-collection-nav [data-brand-tag]').forEach(link => tags.add(link.dataset.brandTag)); return tags;
    }
    isBrand(tag) { return tag.startsWith('brand-') || this.known.has(tag); }
    context() {
      const url = new URL(location.href), base = new URL(this.dataset.baseUrl, location.origin), tail = url.pathname.startsWith(base.pathname.replace(/\/$/, '') + '/') ? url.pathname.slice(base.pathname.replace(/\/$/, '').length + 1) : '';
      const legacy = tail ? tail.split('+').map(part => { try { return decodeURIComponent(part); } catch { return part; } }) : [];
      const query = url.searchParams.getAll('filter.p.tag').flatMap(value => value.split(',')).filter(Boolean);
      const brands = [...new Set([...query, ...legacy].filter(tag => this.isBrand(tag)))];
      const collectionBrand = this.dataset.collectionBrand || document.querySelector('catalina-collection-nav[data-kind="brands"]')?.dataset.collectionBrand;
      if (!brands.length && collectionBrand) brands.push(collectionBrand);
      return { url, base, legacy, brands, collectionBrand };
    }
    clearBrandQuery(params) {
      const keep = params.getAll('filter.p.tag').flatMap(value => value.split(',')).filter(value => !this.isBrand(value));
      params.delete('filter.p.tag'); keep.forEach(value => params.append('filter.p.tag', value)); params.delete('page'); params.delete('section_id'); params.delete('sections');
    }
    withBrand(url, tags, context, preserveOtherLegacy = false) {
      const legacy = preserveOtherLegacy ? context.legacy.filter(tag => !this.isBrand(tag)) : [];
      if (this.dataset.filterStyle === 'query') tags.forEach(tag => url.searchParams.append('filter.p.tag', tag));
      else legacy.push(...tags);
      if (legacy.length) url.pathname = url.pathname.replace(/\/$/, '') + '/' + legacy.map(encodeURIComponent).join('+');
      return url;
    }
    brandURL(link, context) {
      const tag = link.dataset.brandTag || '', direct = this.dataset.mode === 'collections' || Boolean(this.dataset.collectionBrand);
      const target = direct ? (tag ? link.dataset.collectionUrl : this.dataset.allUrl) : this.dataset.baseUrl;
      const url = new URL(target, location.origin); url.search = context.url.search; this.clearBrandQuery(url.searchParams);
      return direct ? url : this.withBrand(url, tag ? [tag] : [], context, true);
    }
    categoryURL(link, context) {
      const url = new URL(link.dataset.collectionUrl, location.origin);
      if (this.dataset.keepSort === 'true' && context.url.searchParams.has('sort_by')) url.searchParams.set('sort_by', context.url.searchParams.get('sort_by'));
      return this.dataset.keepBrand === 'true' ? this.withBrand(url, context.brands, context) : url;
    }
    refresh() {
      this.known = this.tags(); const context = this.context();
      this.querySelectorAll('[data-ccn-link]').forEach(link => {
        if (link.dataset.custom === 'true') return;
        const isBrand = this.dataset.kind === 'brands', isAll = link.hasAttribute('data-ccn-all');
        const url = isBrand ? this.brandURL(link, context) : this.categoryURL(link, context);
        link.href = url.href;
        const active = isBrand ? (isAll ? !context.brands.length : context.brands.includes(link.dataset.brandTag)) : (isAll ? this.dataset.baseUrl === this.dataset.allUrl || Boolean(context.collectionBrand) : link.dataset.collectionHandle === this.dataset.collectionHandle);
        link.classList.toggle('is-current', active); if (active) link.setAttribute('aria-current', 'page'); else link.removeAttribute('aria-current');
      }); this.queue();
    }
    queue() { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => this.update()); }
    update() {
      const view = this.viewport.getBoundingClientRect(), list = this.list.getBoundingClientRect(), rtl = getComputedStyle(this).direction === 'rtl';
      const left = list.left < view.left - 1, right = list.right > view.right + 1;
      this.previous.disabled = rtl ? !right : !left; this.next.disabled = rtl ? !left : !right;
      this.dataset.overflow = String(left || right);
    }
    step(direction) {
      const sign = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
      this.viewport.scrollBy({ left: direction * sign * this.viewport.clientWidth * .7, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    reveal(item) {
      const view = this.viewport.getBoundingClientRect(), rect = item.getBoundingClientRect();
      if (rect.left < view.left || rect.right > view.right) this.viewport.scrollBy({ left: rect.left - view.left - (view.width - rect.width) / 2, behavior: 'instant' });
      this.queue();
    }
    revealCurrent() { const current = this.querySelector('[data-ccn-link].is-current'); if (current) this.reveal(current); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
